export default class Thanks {
    constructor() {
        this.init();
    }

    init() {
        this.addThanks();
    }

    addThanks() {
        const $body = document.body;
        const $open = document.querySelector('.js-thanks_open');

        $open.addEventListener('click', () => setTimeout(() => {
            window.scroll(0, 0);
            $body.classList.add('-after_tweet');
        }, 500));
    }
}